<div>
  <h5 *ngIf="title">{{ title | msg | async }}</h5>

  <div class="list-group-item flex-column" *ngFor="let item of listItems">
    <div class="w-100 mt-3" *ngIf="item.name">
      <h6 class="mb-1">{{ item.name | msg | async }}</h6>
    </div>
    <app-list-item [item]="item"></app-list-item>
  </div>
</div>